import styled from "styled-components"

const CustomArrow = styled.button`
  border: none;
  background: black;
  border-radius: 50%;
  font-weight: bold;

  &:hover {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
    border: 2px ${(props) => props.theme.a_color_gradients.a_light} solid;
  }
  &:focus {
    border: 2px ${(props) => props.theme.a_color_gradients.a_light} solid;
  }
  &::before {
    content: "" !important;
  }
  & span::before {
    font-size: 20px;
    color: #fff;
    display: block;
    font-family: revicons;
    text-align: center;
    z-index: 2;
    position: relative;
  }
  & span[data-direction="right"]::before {
    content: "\\E825";
  }

  & span[data-direction="left"]::before {
    content: "\\E824";
  }
`

const CustomDot = styled.button`
  &[data-active="true"] {
    background-color: black;
  }
  &[data-active="false"] {
    background-color: white;
  }
  &:focus {
    background-color: black;
    box-shadow: 0 0 5px white, 0 0 5px white;
  }
`

export { CustomArrow, CustomDot }
